import PromisedResource from './PromisedResource'
import { JSONAPISource } from '@orbit/jsonapi'
import { ClientCampaignRecord, ClientRecord, ContractRecord } from 'types/OrbitTypes'

function getOptions(year?: number, month?: number, programGroups?: boolean) {
  const options = {sources: {remote: {}}}

  if(programGroups) {
    options['sources']['remote']['include'] = ['program_group']
  }

  if(year || month) {
    options['sources']['remote']['settings'] = {
      params: {
        year: year,
        month: month,
      }
    }
  }

  return options
}

type ClientCampaignsResourceProps = {
  remote: JSONAPISource
  contractOrClient: ContractRecord | ClientRecord
  year?: number
  month?: number
  programGroups?: boolean
}

export default class ClientCampaignsResource extends PromisedResource<ClientCampaignRecord[]> {
  constructor({remote, contractOrClient, year, month, programGroups = false} : ClientCampaignsResourceProps) {
    super(remote.query(q => q.findRelatedRecords(contractOrClient, 'clientCampaigns'), getOptions(year, month, programGroups)))
  }
}
